import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { KvkkDialogComponent } from 'app/admin/components/yoklama/kvkk/kvkk-dialog.component';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KvkkGuard implements CanActivate {
  constructor(
    private auth: UnifiedAuthService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    const user = this.auth.userValue?.data?.[0];



    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }

    const approvals = user.kvkkApprovals ?? [];

    const hasWebAccepted = approvals?.some(
      (x) => x?.Source === 'web' && (x?.IsAccepted ?? false) === true,
    );

    if (hasWebAccepted) return true;

    const isMobile = window.innerWidth < 768;

    const result = await firstValueFrom(
      this.dialog
        .open(KvkkDialogComponent, {
          panelClass: isMobile ? 'kvkk-dialog-mobile' : 'kvkk-dialog-desktop',
          backdropClass: 'kvkk-backdrop',
          disableClose: true,

          width: isMobile ? '100vw' : '800px',
          maxWidth: isMobile ? '100vw' : '800px',
          height: isMobile ? '100vh' : '600px',

          data: { user },
        })
        .afterClosed(),
    );

    // 🔥 KRİTİK
    if (result !== true) {
      //  this.router.navigate(['/login']); // veya /blocked
      return false;
    }

    return true;
  }
}
